<template>
  <div class="profile">
    <div class="main-wrapper">
      <layout-headerApp></layout-headerApp>
      <!-- Page Wrapper -->
      <div class="page-wrapper job-wrapper" style="font-family: 'CircularStd', sans-serif;
        font-size: .9375rem;
        color: #1f1f1f;
        background-color: #f7f7f7;
        min-height: 100%;
        overflow-x: hidden;">

        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
                      <div class="col-md-12">
                        <div
                          class="alert alert-danger alert-dismissible fade show"
                          role="alert"
                          v-if="error"
                        >
                          <strong>Error!</strong> {{ error }}
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div
                          class="alert alert-success alert-dismissible fade show"
                          role="alert"
                          v-if="message"
                        >
                          <strong>Success!</strong> {{ message }}
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      </div>
                    </div>
          <div class="card mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="profile-view">
                    <div class="profile-basic">
                      <div class="row">
                        <div class="col-md-5">
                          <div class="profile-info-left">
                            <h3 class="user-name m-t-0 mb-0">
                              {{ app.applicant.firstName + " " + app.applicant.lastName }}
                            </h3>
                            <h6 class="text-muted">{{app.applicant.email}}</h6>
                            <div class="staff-id">
                              Gender : {{ app.applicant.gender }}
                            </div>
                            <div class="small doj text-muted">
                              Contact : {{ app.applicant.phone1 }}
                            </div>
                            <!-- <div class="staff-msg">
                              <router-link to="/chat" class="btn btn-custom"
                                >Send Message
                              </router-link>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-md-5">
                          <ul class="personal-info">
                            <li>
                              <div class="title-label">Vacancy:</div>
                              <div class="text">
                                {{ app.vacancy.jobProfile.title }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Department:</div>
                              <div class="text">{{ app.vacancy.jobProfile.department.name }}</div>
                            </li>
                            <li>
                              <div class="title-label">Level:</div>
                              <div class="text">
                                <a href="">{{ app.vacancy.jobProfile.rank.rankName }}</a>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div class="col-md-2">
                          <div class="submit-section" v-if="myAccount">
											      <button class="btn btn-primary submit-btn" @click="CompleteProfile" type="submit">Submit Application</button>
										      </div>
                          <div v-if="!myAccount">
                           <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 0"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-purple"></i> Processing
                          </a>

                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 7"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-purple"></i> Unqualified
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 1"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-success"></i> Accepted
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 2"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Test
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 3"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Interview Scheduling
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 4"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Interview 
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 5"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Negotiation
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 6"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Medical
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 8"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-danger"></i> Rejected 
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 20"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-danger"></i> Uncompleted
                          </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="tab-content">
            <!-- Profile Info Tab -->
            <div
              id="emp_profile"
              class="pro-overview tab-pane fade show active"
            >
              <div class="row">
                <div class="col-md-6 u-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Experience
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click="openExperience"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div class="experience-box">
                        <ul class="experience-list">
                          <li
                            v-for="item in app.applicant.applicantExperiences"
                            :key="item.id"
                          >
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <a href="#/" class="name">{{
                                  item.companyName
                                }}</a>
                                <div>{{ item.position }}</div>
                                <span class="time"
                                  >{{ new Date(item.startYear).toLocaleString('default', { month: 'short' })}} {{new Date(item.startYear).getFullYear() }} -
                                  {{ new Date(item.endYear).toLocaleString('default', { month: 'short' })}} {{new Date(item.endYear).getFullYear() }}</span
                                >
                                <hr />
                                <span>{{ item.description}}</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Education Informations
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click="openEducation"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div class="experience-box">
                        <ul class="experience-list">
                          <li
                            v-for="item in app.applicant.applicantEducations"
                            :key="item.id"
                          >
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <a href="#/" class="name">{{
                                  item.institute
                                }}</a>
                                <div>{{ item.discipline }}</div>
                                <span class="time"
                                  >{{ new Date(item.startYear).toLocaleString('default', { month: 'short' })}} {{new Date(item.startYear).getFullYear() }} -
                                  {{ new Date(item.endYear).toLocaleString('default', { month: 'short' })}} {{new Date(item.endYear).getFullYear() }}</span
                                >
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 d-flex">
                  <div class="card profile-box flex-fill" style="background-color: #ff9b44 !important; color: #fff !important;" v-if="(app.status == 3 || app.status == 4) && app.applicationInterviewScheduling">
                    <div class="card-body">
                      <h3 class="card-title">
                        Interview Schedule
                      </h3>
                      <div v-if="!app.applicationInterviewScheduling.confirmedTime">
                        <span>You are invited for an interview on {{app.applicationInterviewScheduling.proposedDate}} at {{app.applicationInterviewScheduling.proposedTime}}.</span><br/>
                        <span>We will like to know your availability. </span><br/>
                        <button  class="btn btn-block mt-5" @click="ReScheduleInterview()" style="background-color: #fff !important; color: #000 !important;">I'm available</button>
                        <button  class="btn btn-secondary btn-block mt-5" @click="openSchedule" style="color: #fff !important;">Reschedule</button>
                      </div>
                      <div v-else>
                        <span>You are invited for an interview on {{app.applicationInterviewScheduling.confirmedDate}} at {{app.applicationInterviewScheduling.confirmedTime}}.</span><br/>
                      </div>
                      
                    </div>
                  </div>
                  <div class="card profile-box flex-fill" style="background-color: #55ce63 !important; color: #fff !important;" v-if="app.status == 5 && app.applicationNegotiation.status == 1">
                    <div class="card-body">
                      <h3 class="card-title">
                        Offer
                      </h3>
                      <span>You have been offerred the job, check below information and give your response</span><br/>
                      <div class="p-0 mb-2" v-if="app.applicationNegotiation.expectedResumptionDate">
                        <p class="mb-0 pl-0 pr-2">Resumption Date</p>
                        <div class="pr-0 custom-control" style="padding-left: 50%">
                          <span>{{app.applicationNegotiation.expectedResumptionDate}}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center p-0 mb-2" v-if="app.applicationNegotiation.negotiatedSalary">
                        <p class="mb-0 col-md-7 pl-0 pr-2">Salary</p>
                        <div class="col-md-5 pr-0 pl-2 custom-control">
                          <span>{{app.applicationNegotiation.negotiatedSalary.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center p-0 mb-2" v-if="app.applicationNegotiation.rank">
                        <p class="mb-0 col-md-7 pl-0 pr-2">Job Level</p>
                        <div class="col-md-5 pr-0 pl-2 custom-control">
                          <span>{{app.applicationNegotiation.rank}}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center p-0 mb-2" v-if="app.applicationNegotiation.probationPeriod">
                        <p class="mb-0 col-md-7 pl-0 pr-2">Probation</p>
                        <div class="col-md-5 pr-0 pl-2 custom-control">
                          <span>{{app.applicationNegotiation.probationPeriod}}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center p-0 mb-2" v-if="app.applicationNegotiation.reportingTo">
                        <p class="mb-0 col-md-7 pl-0 pr-2">Reporing To</p>
                        <div class="col-md-5 pr-0 pl-2 custom-control">
                          <span>{{app.applicationNegotiation.reportingTo}}</span>
                        </div>
                      </div>
                      <button  class="btn btn-block mt-2" @click="acceptApplication" style="background-color: #fff !important; color: #000 !important;">Accept</button>
                      <button  class="btn btn-secondary btn-block mt-2" @click="rejectApplication" style="color: #fff !important;">Reject</button>
                    </div>
                  </div>
                  <div class="card profile-box flex-fill" style="background-color: #fc6075 !important; color: #fff !important;" v-if="app.status == 8">
                    <div class="card-body">
                      <h3 class="card-title">
                        Rejected
                      </h3>
                      <span>{{app.rejectReason}}</span><br/>
                      
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Other Applications
                        
                      </h3>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Profile Info Tab -->
          </div>
        </div>
        <!-- /Page Content -->
        <experience-modal
          :model="app.applicant.applicantExperiences"
          :id="app.applicantId"
          :dialog="experienceDialog"
          v-if="experienceDialog"
          :method="closeExperience"
        ></experience-modal>
        <education-modal
          :model="app.applicant.applicantEducations"
          :id="app.applicantId"
          :dialog="educationDialog"
          v-if="educationDialog"
          :method="closeEducation"
        ></education-modal>
        <skill-modal
          :model="skillLevels"
          :grades="skillGrades"
          :id="app.id"
          :skillId="0"
          :dialog="skillDialog"
          v-if="skillDialog"
          :method="FinishApplying"
        ></skill-modal>
        <v-dialog v-model="scheduleDialog" max-width="500px">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="form-header">
                    <h3>Schedule Interview Date</h3>
                    <table class="w-100">
                    <tr>
                <td class="d-flex align-items-center p-0 mb-2 mt-3">
                  <p class="mb-0 col-md-5 pl-0 pr-2"><i class="la la-check"></i> Schedule Date</p>
                  <div class="col-md-7 pr-0 pl-2 custom-control">
                  <input
                    type="date"
                    class="form-control"
                    v-model="proposedDate"
                  />
                  </div>
                </td>
              </tr>
              <tr>
                <td class="align-items-center p-0 mb-2" v-if="changeTime">
                  <p class="mb-0"> Schedule time</p>
                  <div class="custom-control">
                    <button type="button" class="btn btn-primary btn-sm" style="margin: 2px" v-for="item in times" :key="item" @click="chooseTime(item)">{{item}}</button>
                  </div>
                </td>
                <td class="d-flex align-items-center p-0 mb-2" v-else>
                  <p class="mb-0 col-md-5 pl-0 pr-2"><i class="pr-3"></i>Schedule time</p>
                  <div class="col-md-7 pr-0 pl-2 custom-control" v-if="app.applicationInterviewScheduling">
                    <span>{{app.applicationInterviewScheduling.confirmedTime}}</span>
                  </div>
                </td>
              </tr>
                    </table>
                  </div>
                  <div class="modal-btn delete-action">
                    <div class="row">
                      <div class="col-6">
                        <a
                          class="btn btn-primary continue-btn"
                          @click="ReScheduleInterview()"
                          data-dismiss="modal"
                          >Confirm</a
                        >
                      </div>
                      <div class="col-6">
                        <a
                          class="btn btn-primary cancel-btn"
                          @click="closeSchedule()"
                          >Cancel</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </v-dialog>
          <v-dialog v-model="rejectDialog" max-width="500px">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="form-header">
                    <h3>Reason</h3>
                    <textarea rows="4" class="form-control" v-model="app.rejectReason" />
                  </div>
                  <div class="modal-btn delete-action">
                    <div class="row">
                      <div class="col-6">
                        <a
                          class="btn btn-primary continue-btn"
                          @click="rejectApplication()"
                          data-dismiss="modal"
                          >Reject</a
                        >
                      </div>
                      <div class="col-6">
                        <a
                          class="btn btn-primary cancel-btn"
                          @click="closeReject()"
                          >Cancel</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </v-dialog>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeaderApp from '@/components/layouts/HeaderApp.vue'
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import ExperienceModal from "@/components/career/ExpModal.vue";
import EducationModal from "@/components/career/EduModal.vue";
import SkillModal from "@/components/career/SkillModal.vue";
import Datepicker from "vuejs-datepicker";
import { required, sameAs } from "vuelidate/lib/validators";
import { jobService } from "@/services/jobService.js";
import { skillsService } from "@/services/skillsService.js";
import { authenticationService } from "@/services/authenticationService";
export default {
  components: {
    LayoutHeaderApp,
    LayoutSidebar,
    ExperienceModal,
    EducationModal,
    SkillModal,
    Datepicker,
  },
  data() {
    return {
      experienceDialog: false,
      educationDialog: false,
      skillDialog: false,
      scheduleDialog: false,
      rejectDialog: false,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      message: '',
      error: '',
      file: null,
      media: 'data:image/jpeg;base64,',
      myAccount: false,
      skillLevels: [],
      skillGrades: [],
      app: {
        id: parseInt(this.$route.params.id),
        applicant: {
          applicantEducations: [],
          applicantExperiences: [],
        },
        vacancy: {
          jobProfile: {
            department: {},
            rank: {}
          },
          
          
        },
        applicationSkills : [],
        applicationInterviewScheduling: {},
        applicationNegotiation: {}
      },
      times: [],
      proposedDate: '',
      changeTime: false,
    };
  },
  watch: {
    proposedDate: function(newVal, oldVal) {
      if(newVal != oldVal){
        if(this.app.applicationInterviewScheduling){
        this.app.applicationInterviewScheduling.confirmedDate = newVal
        if(this.app.applicationInterviewScheduling.confirmedDate === undefined) {
         this.getApplicationTime();
        }
        }
        this.changeTime = true
      }
    }
  },
  mounted() {
    console.log(`app.vacancy`, this.app)
    if (this.$route.params.id) {
      this.GetApplication();
      // console.log(this.currentUser);
      
    } else {
      this.$route.push("/joblist");
    }
    // Date Time Picker
          if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // if ($(".floating").length > 0) {
    //   $(".floating")
    //     .on("focus blur", function (e) {
    //       $(this)
    //         .parents(".form-focus")
    //         .toggleClass(
    //           "focused",
    //           e.type === "focus" || this.value.length > 0
    //         );
    //     })
    //     .trigger("blur");
    // }
    
  },
  methods: {
    getApplicationTime(){
      jobService.getApplicationInterviewTime(this.app.id, this.app.applicationInterviewScheduling.confirmedDate)
        .then(
          m => {
            this.times = m
          }
        )
    },
    openEducation() {
      this.educationDialog = true;
      console.log(this.educationDialog)
    },
    openSchedule() {
      this.proposedDate = (this.app.applicationInterviewScheduling) ? this.app.applicationInterviewScheduling.proposedDate : ''
      this.getApplicationTime()
      this.scheduleDialog = true;
    },
    openExperience() {
      
      this.experienceDialog = true;
    },
    closeSchedule() {
      this.scheduleDialog = false
    },
    openReject(){
      this.rejectDialog = true
    },
    closeReject(){
      this.rejectDialog = false
    },
    closeEducation(complete) {
      if(complete){
        jobService.getApplication(this.app.id).then(
          (model) => {
          this.app = model;
          this.educationDialog = false;
        },
        (error) => {
          this.error = error;
        }
      );
      }else{
      this.educationDialog = false;
      }
    },
    chooseTime(time){
      this.app.applicationInterviewScheduling.confirmedTime = time
      this.changeTime = false
    },
    closeExperience(complete) {
      if(complete){
        jobService.getApplication(this.app.id).then(
          (model) => {
          this.app = model;
          this.experienceDialog = false;
        },
        (error) => {
          this.error = error;
        }
      );
      }else{
      this.experienceDialog = false;
      }
      
    },
    ReScheduleInterview() {
      jobService.confirmorReschedule(this.app.applicationInterviewScheduling)
      .then((m) => {
        //await jobService.activeApplicationInterviewers(this.app.id)
        jobService.getApplication(this.app.id).then(
        (model) => {
          this.app = model;
          this.scheduleDialog = false;
        },
        (error) => {
          this.error = error;
        }
      );
      })
    },
    GetApplication() {
      jobService.getApplication(this.app.id).then(
        (model) => {
          this.app = model;
          this.myAccount =
          this.app.status == 20;
          this.app.applicationInterviewScheduling = model.applicationInterviewScheduling ? model.applicationInterviewScheduling : {}
          
        jobService.getJobSkillLevels(this.app.vacancy.jobProfileId)
            .then( m => {
              this.skillLevels = m
              skillsService.getskillGrades(this.app.vacancy.companyId).then(
                (model) => {
                  this.skillGrades = model;
                },
                (error) => {
                  error = error;
                  }
              );
            })
        },
        (error) => {
          this.error = error;
        }
      );
    },
    async acceptApplication() {
      this.app.status = 6
      //await jobService.updateApplication(this.app)
      this.app.applicationMedical = {
        applicationId: this.app.id
      }
      jobService.createApplicationMedical(this.app.id, this.app.applicationMedical)
        .then(
          m => {
            jobService.getApplication(this.app.id)
            .then(
                m => {
            this.app = m
          }
              )
          })
    },

    rejectApplication() {
      this.app.status = 8
      jobService.updateApplication(this.app)
        .then(
          m => {
            this.closeReject()
            jobService.getApplication(this.app.id)
            .then(
                m => {
            this.app = m
          }
              )
          }
        )
    },
    CompleteProfile(){
      
      if(confirm("Are you sure you have completed your application profile?")) {
        if(this.skillLevels.length > 0){
          this.skillDialog = true
        }else{
          this.FinishApplying(true)
        }
      }
    },
    FinishApplying(complete) {
      
      if(complete) {
        jobService
          .finishApplying(
            this.app.id,
          )
          .then(
            (m) => {
              this.message = "Your application has been submitted successfully"
              this.skillDialog = false
              jobService.getApplication(this.app.id).then(
        (model) => {
          this.app = model;
          this.myAccount =
        this.app.status == 20;
        },
        (error) => {
          this.error = error;
        }
      );
            },
            (error) => {
              this.error = error;
            }
          );
      }
    },
  },
  name: "appdetail",
};
</script>


// WEBPACK FOOTER //
// src/components/career/forms.vue